import { CampaignLevel } from "./campaign-level.model";

    /**
     * @description
     *  Modelo de una zona de campaña.
     *
     * @see gigot-backend/ViewModels/Campaign/CampaignZonaDto.cs
     */

export class CampaignZone {

	public campaignId: number;
	public campaignLevel: CampaignLevel;
	public campaignLevelId: number;
	public dateCC: Date;
	public dateEndOrder: Date;
	public dateMain: Date;
	public datePick: Date;
	public dateStartOrder: Date;
	public id: number;
	public zona: string;
	public zonaId: number;

    /**
     * @description
     *	Construye una zona de campaña con una semántica vacía. Nótese que no
	 *	es lo mismo que construir una zona con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Una zona de campaña vacía.
     */
    public static empty(): CampaignZone {
        const campaignZone: CampaignZone = new CampaignZone();
		campaignZone.campaignId = undefined;
		campaignZone.campaignLevel = CampaignLevel.empty();
		campaignZone.campaignLevelId = undefined;
		campaignZone.dateCC = undefined;
		campaignZone.dateEndOrder = undefined;
		campaignZone.dateMain = undefined;
		campaignZone.datePick = undefined;
		campaignZone.dateStartOrder = undefined;
		campaignZone.id = undefined;
		campaignZone.zona = "";
		campaignZone.zonaId = undefined;
        return campaignZone;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicCampaignZone
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
    public static from(anemicCampaignZone: CampaignZone): CampaignZone {
		if (!anemicCampaignZone) return undefined;
        const campaignZone: CampaignZone = CampaignZone.empty();
		campaignZone.campaignId = anemicCampaignZone.campaignId;
		campaignZone.campaignLevel = CampaignLevel.from(campaignZone.campaignLevel);
		campaignZone.campaignLevelId = anemicCampaignZone.campaignLevelId;
		campaignZone.dateCC = new Date(anemicCampaignZone.dateCC);
		campaignZone.dateEndOrder = new Date(anemicCampaignZone.dateEndOrder);
		campaignZone.dateMain = new Date(anemicCampaignZone.dateMain);
		campaignZone.datePick = new Date(anemicCampaignZone.datePick);
		campaignZone.dateStartOrder = new Date(anemicCampaignZone.dateStartOrder);
		campaignZone.id = anemicCampaignZone.id;
		campaignZone.zona = anemicCampaignZone.zona;
		campaignZone.zonaId = anemicCampaignZone.zonaId;
        return campaignZone;
    }
}
